import React, {type ReactNode} from 'react';

const displayContents = {display: 'contents'} as const;

export const SensitiveInfoWrapper = ({children}: {children: ReactNode}) => (
  <div className="meticulous-redact-recording" style={displayContents}>
    {children}
  </div>
);
